<ng-container>


    <div class="card display-container-card">
        <div class="card-header card-header-bg display-container-card-bg">
            <p class="card-header-heading"> Add / Edit Remainders </p>
        </div>

        <div class="card-body">
            <div class="table-responsive">
                <table class="table card-table table-vcenter text-nowrap">
                    <!-- <table class="table table-striped table-responsive mt-5 table card-table table-vcenter text-nowrap"> -->
                    <thead>
                        <tr>
                            <th class="" scope="col">
                                <a (click)="isCreate = true; addEditFormVisible = true;" class="btn btn-primary btn-sm">
                                    <i class="fa fa-plus"></i> ADD REMAINDER </a>
                            </th>

                            <th class="" scope="col"></th>
                            <th class="" scope="col"></th>
                            <th class="" scope="col"></th>
                            <th class="" scope="col"></th>
                            <th class="" scope="col"></th>


                            <!-- <th class="" scope="col"> </th> -->
                            <th class="reloadRemainders" (click)="refreshOnlyChildData()" scope="col">
                                <a class="link-dark"> <i class="fa fa-rotate-right"></i> Refresh </a>
                            </th>
                            <!-- <th class="" scope="col"> </th> -->

                        </tr>

                        <tr>
                            <th class="bg-primary" scope="col"></th>
                            <th class="bg-primary" scope="col">ID</th>
                            <th class="bg-primary" scope="col">Title</th>
                            <th class="bg-primary" scope="col">Status </th>

                            <th class="bg-primary" scope="col">Due Date</th>
                            <th class="bg-primary" scope="col">Completed On</th>
                            <th class="bg-primary" scope="col">Timestamps</th>



                        </tr>
                    </thead>
                    <tbody>

                        <tr *ngIf="count < 1">
                            <td>No Records Found</td>
                        </tr>

                        <ng-container *ngIf="fetchedAllData && count > 0">



                            <tr *ngFor="let key of Object.keys(fetchedAllData)">
                                <td>
                                    <button (click)="fetchValueAndDisplayForm(fetchedAllData[key].id)"
                                        class="btn btn-secondary btn-sm">
                                        <i class="fa fa-pencil-square-o"></i> Edit </button>

                                </td>
                                <td>{{ fetchedAllData[key].id }}</td>
                                <td>{{ fetchedAllData[key].title | nullWithDefault   }}</td>

                                <td>
                                    <span class="badge badge-success"
                                                *ngIf="fetchedAllData[key].status == '3'">Done</span>
                                           
                                            <span class="badge badge-warning"
                                                *ngIf="fetchedAllData[key].status == '1'">To Do</span>
                                            <span class="badge badge-info"
                                                *ngIf="fetchedAllData[key].status  == '2'">In Progress</span>
                                         

                                </td>
                                    
                           

                                <td>
                                    
                                    <p>{{ fetchedAllData[key].due_date ? ( fetchedAllData[key].due_date | momentDateTransformPipe : ('Do MMM, YYYY') ): ''   }} </p>

                                    <small> {{  fetchedAllData[key].due_date ? (fetchedAllData[key].due_date | momentDateDiffPipe ): ''  }} </small>
                                </td>

                                <td>
                                    
                                    <p>{{ fetchedAllData[key].completed_date ? ( fetchedAllData[key].completed_date | momentDateTransformPipe : ('Do MMM, YYYY') ): ''   }} </p>
                              
                              
                                    <small> {{  fetchedAllData[key].completed_date ? (fetchedAllData[key].completed_date | momentDateDiffPipe ): ''  }} </small>
                              
                                </td>

                                

                            








                                <td>

                                    <p>
                                        <small>
                                            Created At :
                                            <!-- <small>{{ fetchedAllData[key].created_at | momentDateTransformPipe : ('YYYY-MM-DD HH:mm:ss ')  }}
                                        </small> -->

                                            <small> {{ fetchedAllData[key].created_at | momentDateDiffPipe  }}
                                                (
                                                {{ fetchedAllData[key].created_at | momentDateTransformPipe : ('hh:mm a MMM Do, YYYY ')  }}
                                                ) </small>

                                        </small>
                                    </p>

                                    <p>
                                        <small>

                                            Updated At :

                                            <!-- <small>{{ fetchedAllData[key].updated_at | momentDateTransformPipe : ('YYYY-MM-DD HH:mm:ss ')  }}
                                        </small> -->
                                            <small> {{ fetchedAllData[key].updated_at | momentDateDiffPipe  }}
                                                (
                                                {{ fetchedAllData[key].updated_at | momentDateTransformPipe : ('hh:mm a MMM Do, YYYY ')  }}
                                                ) </small>

                                        </small>
                                    </p>
                                </td>

                            </tr>

                          



                        </ng-container>









                    </tbody>
                </table>
            </div>
        </div>
    </div>





    <section class="fullScreenPopup" *ngIf="addEditFormVisible">
        <div class=" text-right mt-1 mb-1" (click)="addEditFormVisible = false; reloadData(); ">
            <button class="btn btn-primary"> <i class="fa fa-arrow-circle-o-left mr-2"></i> CANCEL</button>
        </div>


        <app-remainders-add-edit [isCreate]="isCreate" [type_of_data]="type_of_data"
            [table_column_id]="table_column_id" [is_credit]="1" [fetchedData]="fetchedValue"
            (reloadData)="reloadData($event)">
        </app-remainders-add-edit>




    </section>



</ng-container>